import numeral from "numeral";

export const numberToCurrency = (number, format = "$0.00") => {
  return numeral(number).format(format);
};
